/**
 * src/admin-ui/src/styles/common.ts
 *
 * Shared responsive layout primitives. Page-level layout follows the
 * full-screen page pattern (components/edge-table) — pages have no
 * headers or containers of their own, so only the responsive switches
 * and the centered state live here.
 */

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

/** Centered spinner/empty-state area (pages and dialogs). */
export const CenteredState = styled(Box)(({ theme }) => ({
  display: "flex",
  minHeight: 240,
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(4),
}));

/** Rendered only on >=sm widths (tables). */
export const DesktopOnly = styled(Box)(({ theme }) => ({
  display: "block",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

/** Rendered only on <sm widths (stacked cards). */
export const MobileOnly = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "grid",
    gap: theme.spacing(2),
  },
}));
